/**
 * Mirrors the **defaults** in `apps/api/src/lib/attachmentLimits.ts` and the
 * `ALLOWED_TYPES` set in `apps/api/src/modules/attachments/routes.ts`.
 *
 * Client-side checks against these are a courtesy for immediate feedback
 * (wireframe 03.1 note 3) — the API enforces both limits independently and is
 * the real control. Since #52 the enforced limits are administrator-configurable
 * and read from the database on every upload. **These two constants are now only
 * the fallback**, used by `AttachmentsSection` before `GET /api/attachments/limits`
 * (#258) resolves, or if that fetch ever fails — the component otherwise uses the
 * live values, so an administrator changing the limit is reflected in the
 * requester-side pre-check and dropzone hint text immediately, with no redeploy.
 */
export const MAX_ATTACHMENT_SIZE_BYTES = 10 * 1024 * 1024; // 10 MB
export const MAX_ATTACHMENTS_PER_REQUEST = 10;

export const ALLOWED_ATTACHMENT_TYPES = new Set([
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'image/png',
  'image/jpeg',
  'image/gif',
]);
